import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select, Row, Col, message, Upload, DatePicker } from "antd";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons";
import axios from "axios";
import { HrApi, imageApi } from "../../../initialpage/hooks/HrApi";
import { useNavigate } from "react-router-dom";

const { Option } = Select;

function getBase64(file, callback) {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => callback(reader.result);
  reader.onerror = (error) => console.error("Base64 error:", error);
}

const EmployeeInformationForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [photoPath, setPhotoPath] = useState("");
  const [designationData, setDesignationData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const navigate = useNavigate();


  const handleBeforeUpload = (file) => {
    console.log(file);
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      return Upload.LIST_IGNORE;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must be smaller than 2MB!");
      return Upload.LIST_IGNORE;
    }

    setLoading(true);
    getBase64(file, async (base64Url) => {
      setImageUrl(base64Url);
      setLoading(false);

      try {
        const response = await fetch(`${imageApi}/upload-base64`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ base64Image: base64Url }),
        });

        if (!response.ok) {
          throw new Error(`Server error: ${response.status}`);
        }

        const data = await response.json();

        setPhotoPath(data.path);
      } catch (error) {
        console.error("Base64 upload failed:", error);
        message.error("Image upload failed! Is the server running?");
      }
    });

    return false; // prevent automatic upload
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload Photo</div>
    </div>
  );

  const onFinish = (values) => {
    if (!imageUrl) {
      message.error("Please upload employee photo");
      return;
    }

    console.log("Submitted values:", {
      ...values,
      image: photoPath, // Base64 image string
    });

    const data = {
      ...values,
      image: photoPath, // Base64 image string
    };
    axios({
      method: "post",
      url: `${HrApi}/hr/emp/postEmployee`,
      data,
      headers: { Authorization: "Bearer ..." },
    }).then((res) => {
      console.log(res);
      if (res.data.data.affectedRows == 1) {
        message.success("Employee information submitted successfully!");
        form.resetFields();
        setImageUrl(null);
        navigate(-1);
      }
    });
  };

  // designation
  useEffect(() => {
    getUsers();
  }, []);
  const getUsers = () => {
    fetch(`${HrApi}/hr/setting/get/designation`)
      .then((res) => {
        if (res.status >= 400) {
          throw new Error("Server responds with error!");
        }
        return res.json();
      })
      .then(
        (data) => {
          setDesignationData(data.items);
        },
        (err) => {
          const mute = err;
        }
      );
  };

  // GET Department DATA
  useEffect(() => {
    DepartmentGet();
  }, []);

  const DepartmentGet = () => {
    fetch(`${HrApi}/hr/setting/get/department`)
      .then((res) => {
        // You have to send it, as I have done below
        if (res.status >= 400) {
          throw new Error("Server responds with error!");
        }
        return res.json();
      })
      .then(
        (users) => {
          console.log(users);
          setDepartmentData(users.items);
        },

        (err) => {
          const mute = err;
        }
      );
  };
  return (
    <div className="page-wrapper">
      <Row
        justify="center"
        align="middle"
        style={{ background: "#f5f5f5", padding: "20px" }}
      >
        <Col xs={24} sm={20} md={16} lg={12}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            style={{
              padding: "24px",
              background: "#fff",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="registrationNo"
                  label="Employee Serial No."
                  rules={[
                    {
                      required: true,
                      message: "Please enter Serial number",
                    },
                    {
                      pattern: /^EMP\d{4}-\d{3}$/,
                      message: "Format should be like EMP2025-001",
                    },
                  ]}
                >
                  <Input placeholder="e.g., EMP2025-001" />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  name="name"
                  label="Employee Name"
                  rules={[
                    { required: true, message: "Please enter employee name" },
                    { min: 3, message: "Name must be at least 3 characters" },
                  ]}
                >
                  <Input placeholder="e.g., John Doe" />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  name="designation"
                  label="Designation"
                  rules={[
                    { required: true, message: "Please select a designation" },
                  ]}
                >
                  <Select
                    placeholder="Select designation"
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {designationData?.map((item) => (
                      <Option
                        key={item.designation_id}
                        value={parseInt(item.designation_id)}
                      >
                        {item.designation}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  name="department"
                  label="Department"
                  rules={[
                    { required: true, message: "Please select a department" },
                  ]}
                >
                  <Select
                    placeholder="Select department"
                    showSearch
                    filterOption={(input, option) =>
                      option?.children
                        ?.toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {departmentData?.map((item) => (
                      <Option
                        key={item.departement_id}
                        value={parseInt(item.departement_id)}
                      >
                        {item.departement}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  name="mobile"
                  label="Mobile Number"
                  rules={[
                    { required: true, message: "Please enter mobile number" },
                    {
                      pattern: /^01[3-9]\d{8}$/,
                      message: "Invalid Bangladeshi mobile number",
                    },
                  ]}
                >
                  <Input placeholder="e.g., 017XXXXXXXX" />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    { type: "email", message: "Please enter a valid email" },
                  ]}
                >
                  <Input placeholder="e.g., john.doe@example.com" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="joiningDate"
                  label="Joining Date"
                  rules={[{ required: true, message: "Please select joining date" }]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    format="DD-MM-YYYY"
                    placeholder="Select joining date"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  name="cadre"
                  label="Cadre"
                // rules={[{ required: true, message: "Please select a cadre" }]}
                >
                  <Select
                    placeholder="Select cadre"
                    showSearch
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {Array.from({ length: 100 }, (_, i) => (
                      <Option key={i + 1} value={`${i + 1}`}>
                        {i + 1} Cadre
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24}>
                <Form.Item
                  label="Employee Photo"
                  required
                  validateStatus={!imageUrl ? "error" : "success"}
                  help={!imageUrl ? "Please upload employee photo" : ""}
                >
                  <Upload
                    name="avatar"
                    listType="picture-card"
                    className="avatar-uploader"
                    showUploadList={false}
                    beforeUpload={handleBeforeUpload}
                  >
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt="avatar"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      uploadButton
                    )}
                  </Upload>
                </Form.Item>
              </Col>
            </Row>

            <Form.Item style={{ textAlign: "center", marginTop: 24 }}>
              <Button
                type="primary"
                className="buttonColor"
                htmlType="submit"
                size="large"
              >
                Submit Employee Information
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default EmployeeInformationForm;
